import {
  Tooltip as ChakraTooltip,
  PlacementWithLogical,
  Show,
  Flex,
  Text,
  Button,
} from "@chakra-ui/react";
import ModalDrawer from "@components/ModalDrawer";
import { ReactNode, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoClose } from "react-icons/io5";

type ResponsiveTooltipProps = {
  title?: ReactNode;
  content?: ReactNode;
  closeDelay?: number;
  placement?: PlacementWithLogical;
};

export const ResponsiveTooltip = ({
  title,
  content,
  closeDelay,
  placement,
}: ResponsiveTooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const renderContent = () => {
    if (content) {
      if (typeof content === "string") {
        return (
          <Text color="textSecondary" fontSize="12px" fontWeight="400" p="4px">
            {content}
          </Text>
        );
      }
      return content;
    }
  };

  return (
    <>
      {/* Desktop Tooltip */}
      <Show above="md">
        <ChakraTooltip
          label={content ? renderContent() : title}
          isOpen={isVisible}
          closeDelay={closeDelay ? closeDelay : 2000}
          onClose={() => setIsVisible(false)}
          pointerEvents="all"
          color="textSecondary"
          fontSize={"12px"}
          bg="backgroundCard"
          p="8px"
          maxW={"200px"}
          borderRadius="8px"
          placement={placement ? placement : "auto"}
        >
          <span style={{ alignSelf: "center" }}>
            <AiOutlineInfoCircle
              fontSize={"14px"}
              onMouseEnter={() => setIsVisible(true)}
              onClick={() => setIsVisible(true)}
            />
          </span>
        </ChakraTooltip>
      </Show>

      {/* Mobile Sheet */}
      <Show below="md">
        <span style={{ alignSelf: "center" }}>
          <AiOutlineInfoCircle
            fontSize={"12px"}
            onClick={() => setIsVisible(true)}
          />
        </span>
        <ModalDrawer
          isOpen={isVisible}
          closeAlert={() => setIsVisible(false)}
          contentProps={{
            p: { base: "1rem", md: "2rem" },
          }}
        >
          <Flex flexDirection="column" gap="1rem" width="100%" py="4">
            <Flex justifyContent="space-between" alignItems="center">
              {title && (
                <Text fontSize="20px" fontWeight="600" mb={2}>
                  {title}
                </Text>
              )}
              <Button
                variant="unstyled"
                // display="flex"
                position={"absolute"}
                right={2}
                p={0}
                height="24px"
                onClick={() => setIsVisible(false)}
                _focus={{
                  boxShadow: "none",
                }}
              >
                <IoClose size={24} color="#075A5A" />
              </Button>
            </Flex>
            {renderContent()}
          </Flex>
        </ModalDrawer>
      </Show>
    </>
  );
};

export default ResponsiveTooltip;
